import { PropertiesDataV } from "./tree";

import * as t from "io-ts";
import { ControlV } from "./controls";

export const SelectorCSSNameV = t.string;
/* would be wise ot make an io-ts typeguard to ensure it's a VALID css class name... 
and then apply that type guard to both the value emitted by the class input (most important)
 and the classes on the way in (not really important)
*/

export type SelectorCSSName = t.TypeOf<typeof SelectorCSSNameV>;

export const CSSSelectorV = t.type({
  name: SelectorCSSNameV,
  type: t.union([t.literal("class"), t.literal("custom")]),
  properties:
    PropertiesDataV /* really PropertiesData is a [key: string]: ValidValue | PropertiesData, not an any */
});

export type CSSSelector = t.TypeOf<typeof CSSSelectorV>;

export const CSSSelectorListV = t.array(CSSSelectorV);
export type CSSSelectorList = t.TypeOf<typeof CSSSelectorListV>;

export const LoadedSelectorDataV = t.exact(
  t.type({
    template: t.string,
    controls: t.array(ControlV),
    selectors: CSSSelectorListV
  })
);

export type LoadedSelectorData = t.TypeOf<typeof LoadedSelectorDataV>;
